import React, {Component} from 'react';

import Router from './config/Routes';

import {Grommet} from "grommet";
import { grommet } from 'grommet/themes';

import {Provider} from 'react-redux'
import store from './store/index';

import ('./static/css/app.css');

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <Grommet theme={grommet}>
                <Router/>
                </Grommet>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js